/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" _fill="#008cff" d="M.86 21.65a.857.857 0 01-.608-.254.872.872 0 01-.229-.814l1.405-5.925a.869.869 0 01.23-.412L15.648.172a.855.855 0 011.216 0l4.444 4.48a.871.871 0 010 1.225L7.347 19.979a.856.856 0 01-.408.23L1.06 21.627a.855.855 0 01-.2.024zm1.162-2.039l2.95-.71-2.245-2.263zM16.206 8.577l-1.01-1.018-9.522 9.597 1.02 1.028zm-2.227-2.244L12.97 5.316l-9.53 9.587 1.019 1.027zm5.506-1.068l-3.228-3.254-2.07 2.08 3.234 3.26z"/>'
  }
})
